<script>
    import { createEventDispatcher, onMount } from "svelte";
  
    export let items = []; // lista de strings
    export let placeholder = "Selecciona una opción";
  
    const dispatch = createEventDispatcher();
  
    let query = "";
    let open = false;
    let dropdownRef;
  
    let selected = null;
  
    // filtrar según búsqueda
    $: filtered = items.filter(i =>
      i.toLowerCase().includes(query.toLowerCase())
    );
  
    function selectItem(item) {
      selected = item;
      query = item;
      open = false;
      dispatch("change", item); // emitir valor al padre
    }
  
    function toggleOpen() {
      open = !open;
      if (open && !query) query = "";
    }
  
    function handleClickOutside(e) {
    if (dropdownRef && !dropdownRef.contains(e.target)) {
      open = false;
    }
  }
  
    onMount(() => {
      document.addEventListener("click", handleClickOutside);
    });
  </script>
  
  <style>
    .dropdown-wrapper {
      position: relative;
      width: 100%;
    }
    .dropdown-list {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      z-index: 10;
      max-height: 200px;
      overflow-y: auto;
      border: 1px solid #dee2e6;
      border-radius: 0.375rem;
      background: white;
    }
    .dropdown-item {
      padding: 8px 12px;
      cursor: pointer;
    }
    .dropdown-item:hover {
      background: #f8f9fa;
    }
  </style>
  
  <div class="dropdown-wrapper" bind:this={dropdownRef}>
    <input
      class="form-select"
      type="search"
      placeholder={placeholder}
      bind:value={query}
      on:focus={toggleOpen}
    />
  
    {#if open}
      <div class="dropdown-list">
        {#if filtered.length === 0}
          <div class="dropdown-item text-muted">No hay resultados</div>
        {:else}
          {#each filtered as item}
          <div
          class="dropdown-item"
          role="button"
          tabindex="0"
          on:click={() => selectItem(item)}
          on:keydown={(e) => (e.key === "Enter" || e.key === " ") && selectItem(item)}
        >
          {item}
        </div>
        
          {/each}
        {/if}
      </div>
    {/if}
  </div>
  